const mediaItems = [
  {
    title: '最新国产高清合集',
    tag: '热门推荐',
    duration: '45:32',
    views: '128.6万',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20visual%20representing%20modern%20video%20streaming%20content%2C%20warm%20golden%20and%20amber%20lighting%20with%20soft%20gradients%2C%20stylized%20media%20player%20interface%20elements%20in%20coral%20tones%2C%20dark%20elegant%20background%20with%20subtle%20geometric%20patterns%2C%20premium%20entertainment%20thumbnail%20aesthetic%2C%20clean%20sophisticated%20digital%20art%20composition&width=600&height=400&seq=media-91md-01&orientation=landscape',
  },
  {
    title: '超清影视在线精选',
    tag: '高清画质',
    duration: '38:15',
    views: '96.3万',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20representation%20of%20cinema%20and%20film%20entertainment%2C%20warm%20coral%20and%20rose%20gold%20color%20palette%2C%20stylized%20film%20frame%20borders%20and%20play%20symbols%2C%20dark%20atmospheric%20background%20with%20soft%20glowing%20accents%2C%20luxurious%20theater%20vibe%2C%20modern%20minimalist%20poster%20design%20style&width=600&height=400&seq=media-91md-02&orientation=landscape',
  },
  {
    title: '热门视频每日上新',
    tag: '今日更新',
    duration: '52:08',
    views: '203.7万',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20digital%20media%20artwork%20with%20warm%20ochre%20and%20terracotta%20gradients%2C%20flowing%20curved%20lines%20suggesting%20motion%20and%20streaming%2C%20sophisticated%20dark%20backdrop%20with%20subtle%20light%20leaks%2C%20premium%20video%20platform%20branding%20aesthetic%2C%20clean%20modern%20composition%20with%20depth%20and%20atmosphere&width=600&height=400&seq=media-91md-03&orientation=landscape',
  },
  {
    title: '91国产视频精选',
    tag: '精品推荐',
    duration: '41:20',
    views: '167.2万',
    img: 'https://readdy.ai/api/search-image?query=Refined%20abstract%20visual%20inspired%20by%20film%20and%20media%20streaming%2C%20warm%20bronze%20and%20copper%20tones%20with%20dark%20elegant%20contrasts%2C%20geometric%20overlay%20patterns%20reminiscent%20of%20media%20controls%2C%20soft%20bokeh%20lighting%20effects%2C%20professional%20grade%20thumbnail%20art%2C%20sophisticated%20and%20inviting%20atmosphere&width=600&height=400&seq=media-91md-04&orientation=landscape',
  },
  {
    title: '高清在线流畅播放',
    tag: '流畅体验',
    duration: '34:55',
    views: '89.1万',
    img: 'https://readdy.ai/api/search-image?query=Contemporary%20abstract%20digital%20composition%20evoking%20streaming%20entertainment%2C%20warm%20amber%20and%20sienna%20color%20harmony%2C%20elegant%20wavy%20motion%20lines%20and%20play%20icon%20motifs%2C%20dark%20premium%20background%20with%20radiant%20highlights%2C%20modern%20cinematic%20poster%20aesthetic%2C%20high%20contrast%20luxurious%20visual%20style&width=600&height=400&seq=media-91md-05&orientation=landscape',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门精选
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            精选91高清视频在线热门内容，每日更新精彩不断
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-primary-500 text-white text-xs rounded-md font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-white text-xs rounded-md whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-white text-2xl"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-950 line-clamp-1 mb-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}